import { Badge, Logo } from '@arcadiapower/shrike';
import { BackgroundColors } from '@arcadiapower/shrike/dist/types/src/types';
import { Link } from '~/components/link';
import { OriginationSource } from '~/typings/graphql';
import { SPONSORED_SOLAR_LANDING_PAGE_URL, WEBSITE_URL } from '~/utils/constants';
import { HeaderWrapper, SubContainer } from './header.style';

export const Header = ({
  badge,
  backgroundColor,
  originationSource,
}: {
  badge?: string;
  backgroundColor?: BackgroundColors;
  originationSource?: OriginationSource;
}) => {
  const URL =
    originationSource === OriginationSource.SponsoredSolar
      ? SPONSORED_SOLAR_LANDING_PAGE_URL
      : WEBSITE_URL;
  return (
    <HeaderWrapper>
      <Link color="primary" href={URL} openInNewTab display="flexbox" aria-label="Go to homepage">
        <Logo scale={3} type="name" variant="dark" />
      </Link>
      {badge && (
        <SubContainer>
          <Badge backgroundColor={backgroundColor ?? 'accent2'}>{badge}</Badge>
        </SubContainer>
      )}
    </HeaderWrapper>
  );
};
